import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AdminSettingsModalState {
  open: boolean;
  tab: 'users' | 'groups';
}

const initialState: AdminSettingsModalState = { open: false, tab: 'users' };

export const adminSettingsModalSlice = createSlice({
  name: 'adminSettingsModal',
  initialState,
  reducers: {
    openModal: (
      state,
      action: PayloadAction<{ tab?: 'users' | 'groups' } | undefined>,
    ) => {
      state.open = true;
      state.tab = action.payload?.tab ?? 'users';
    },
    closeModal: (state) => {
      state.open = false;
    },
    toggleModal: (state) => {
      state.open = !state.open;
    },
  },
});

export const { openModal, closeModal, toggleModal } =
  adminSettingsModalSlice.actions;

export default adminSettingsModalSlice.reducer;
